import { InputAdornment as Mui4InputAdornment } from '@material-ui/core'
import {
  default as Mui5InputAdornment,
  InputAdornmentProps as Mui5InputAdornmentProps,
} from '@mui/material/InputAdornment'
import { Children, forwardRef } from 'react'
import { OsTextFieldVersion } from '../form/TextField'
import { useComponentVersion } from '../hooks'

const isEmptyChildren = (children: React.ReactNode) => Children.toArray(children).length === 0

export type InputAdornmentProps = Omit<Mui5InputAdornmentProps, 'classes'>

export const InputAdornment = forwardRef<HTMLDivElement, InputAdornmentProps>(({ children, ...props }, ref) => {
  const version = useComponentVersion('text_field')

  if (isEmptyChildren(children)) return null

  switch (version) {
    case OsTextFieldVersion.V2:
      return <Mui5InputAdornment {...props}>{children}</Mui5InputAdornment>
    default:
      return <Mui4InputAdornment {...props}>{children}</Mui4InputAdornment>
  }
})
